import { UserRole } from '@ils/static/enums.js';
import { onlineStatus } from '../checks/onlineStatus.js';
import type { RolesWithPermissions } from '../permissions.js';

export const examCenterManager: RolesWithPermissions['examCenterManager'] = {
  permissions: {
    OSCEs: { viewnew: false, viewratedonce: false, create: false, modify: false, delete: false },
    instructionCategories: { view: false },
    answers: {
      createempty: false,
      modifyaudio: false,
      modifytranscript: false,
      create: true,
      modify: false,
      delete: false,
    },
    examdays: {
      view: false,
      create: true,
      modify: true,
      modifymissingcandidates: true,
      schedule: true,
      printcandiates: true,
      sendinfomail: true,
      viewselect: true,
      operate: true,
      viewstatistics: false,
      delete: true,
    },
    finalratings: { view: false, create: false, modify: false, delete: false },
    invoices: { create: false, view: false },
    mails: { modify: false, view: false, create: false, delete: false },
    orders: {
      createmanual: false,
      modifycomment: false,
      move: false,
      revoke: false,
      setpaid: false,
      view: false,
      modify: false,
      create: false,
    },
    results: { sendmail: false, view: false },
    certificates: { sendmail: false, view: false },
    ratings: {
      modifyownnotes: false,
      view: false,
      viewoverview: false,
      viewothers: false,
      create: false,
      modify: false,
      delete: false,
    },
    shortTokens: {
      view: true,
      create: (user, token) => !!token?._meta?.allowedExamDayIDs.includes(token.examDayID),
      modify: false,
      delete: (user, token) => !!token?._meta?.allowedExamDayIDs.includes(token.examDayID),
    },
    slots: {
      createfallback: true,
      extend: true,
      rate: false,
      usefallbackactor: true,
      view: false,
      viewothers: false,
      delete: (user, slot) => !!slot?._meta?.allowedSlotIDs.includes(slot._id),
      spectate: true,
      modifycomment: true,
      create: true,
      modify: (user, slot) => !!slot?._meta?.allowedSlotIDs.includes(slot._id),
    },
    timeline: {
      view: true,
      viewadmin: true,
    },
    users: {
      create: false,
      modify: (user, userData) => {
        if (!userData) return false;
        return userData._id === user._id;
      },
      modifyassignedosces: false,
      view: true,
      delete: false,
      impersonate: false,
    },
    reportedErrors: { create: false, view: false, resolve: false },
    termins: { create: false, view: false, schedule: false },
    timeslots: { view: false, create: false, delete: false },
    osceGroups: { create: false, modify: false, delete: false },
    scores: { create: false, modify: false, delete: false },
    eventLogs: { create: true, modify: false, delete: false },
    files: { create: true, modify: true, delete: false },
    onlineStatus,
    counters: { create: true, modify: true, delete: false },
    dataViewConfigs: { create: true, modify: true, delete: false },
    examDayReservations: { create: true, modify: true, delete: true },
    locations: { create: false, modify: false, delete: false, view: false },
  },
  allowedPages: {
    start: 1,
    scheduling: 1,
    users: 1,
    spectate: 1,
    'check-in': 1,
    'editor-exam': 1,
  },
  examDayFilter: user => {
    return {
      archived: { $ne: true },
      locationID: { $in: user.roles.find(r => r.name === UserRole.EXAMCENTERMANAGER)?.contexts ?? [] },
      // end: {
      //   $gte: DateTime.now().minus({ hours: 12 }).toJSDate(),
      //   $lte: DateTime.now().plus({ weeks: 2 }).toJSDate(),
      // },
    };
  },
};
